interface FormState {
  [key: string]: string | File | null;
}

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('main > form:not(.filter):not(:has(.filter))') as HTMLFormElement;
  if (!form) return;

  const initialState = new FormData(form);
  const initialMap: FormState = Object.fromEntries(initialState.entries());
  let isDirty = false;

  const checkFormChanges = (): void => {
    const compareFileValues = (initial: File | null, current: File | null): boolean => {
      if (!initial && !current) return true;
      if (!initial || !current) return false;
      return (
        initial.name === current.name &&
        initial.size === current.size &&
        initial.type === current.type
      );
    };

    const hasRemovedKeys = (): boolean => {
      for (const key of Object.keys(initialMap)) {
        if (!(key in currentMap)) {
          return true;
        }
      }
      return false;
    }

    const hasChanges = (): boolean => {
      for (const [key, value] of Object.entries(currentMap)) {
        const initialValue = initialMap[key];

        if (value instanceof File) {
          const initialFile = initialValue instanceof File ? initialValue : null;
          if (!compareFileValues(initialFile, value)) {
            return true;
          }
        } else {
          if (initialValue?.toString() !== value?.toString()) {
            return true;
          }
        }
      }

      return false;
    }

    const currentState = new FormData(form);
    const currentMap: FormState = Object.fromEntries(currentState.entries());

    isDirty = hasChanges() || hasRemovedKeys();
  };

  $(form)
    .on('input', checkFormChanges)
    .on('change', checkFormChanges)
    .on('submit', () => {
      isDirty = false;
    });

  window.addEventListener('beforeunload', (event: BeforeUnloadEvent) => {
    if (isDirty) {
      event.preventDefault();
    }
  });
});
